import { render, staticRenderFns } from "./companyCardSet.vue?vue&type=template&id=4781db6b&"
import script from "./companyCardSet.vue?vue&type=script&lang=js&"
export * from "./companyCardSet.vue?vue&type=script&lang=js&"
import style0 from "./companyCardSet.vue?vue&type=style&index=0&id=4781db6b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports